import React from 'react';
import clone from 'clone';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import Overlay from '../../../../presentation/Overlay';
import ProgramFeesDialog from '../../../../presentation/ProgramFeesDialog';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import layout from './layout.json';

// Constant date value needed for various calculations
const CONST_TODAY = new Date();

// Other date constants we need
const CONST_DAY = String( CONST_TODAY.getDate() ).padStart( 2, '0' );
const CONST_MONTH = String( CONST_TODAY.getMonth() + 1 ).padStart( 2, '0' ); // Takes care of 0 for January, dumb JS...
const CONST_YEAR = CONST_TODAY.getFullYear();
const CONST_YYYYMMDD = CONST_YEAR + CONST_MONTH + CONST_DAY;

// Utility function, returns if the initial row by looking to see if the program is active
// if the program is active -> returns a 1, if the program is not active returns a 0, if the program is in the future returns a 2
function isInitialRow( row ){
  if( row.ACTIVE_TEXT === 'Active' ){
    return 1;
  } else {
    // Taking a look at Fee End date
    const CCFileDateEnd = row.CCFileDateEnd;

    if( CONST_YYYYMMDD > CCFileDateEnd ){
      return 0; // Past (inactive)
    
    // Future
    } else {
      return 2;
    }
  }
}

// Utility function to know if the data values is in the past, returns {true} fi value is in the past
// @arg: date[str] -> The date value in format MM/DD/YYYY (Pgm_Ends)
function pastValue( date ) {
  const pgmDay = date.substring( 3, 5 );
  const pgmMonth = date.substring( 0, 2 );
  const pgmYear = date.substring( 6, 10 );

  if( CONST_YYYYMMDD > ( pgmYear + pgmMonth + pgmDay ) ){
    return true;
  }

  return false;
}

// Utility function to format a YYYYMMDD to MM/DD/YYYY
// @r: returns a string -> MM/DD/YYYY used in _TEXT cells
function convertDate( date ){
  let dateValue = date.toString();
  return ( dateValue.substring( 4,6 ) + '/' + dateValue.substring( 6,8 ) + '/' + dateValue.substring( 0,4 ) );
}

// Returns (true) if there is a search filter given for any value, else returns (false)
// @arg: filters[Object] -> {filtername: value, etc.} The key value store
// @r: true if filters contains a valid value, else false
function ifHasFilters( filters ) {
  if( filters === null || filters === undefined ){
    return false;

  // If filters object exist
  } else {

    // String array
    const keys = Object.keys( filters );
    for( let i = 0; i < keys.length; i++ ){

      // If something other than an empty string is found
      if( filters[ keys[i] ] !== '' ){
        return true;
      }
    }

    // If all values are empty
    return false;
  }
}

// Custom icon that hold row properties, these are copy and edit and pass these rows
// to the parent on click
class DialogIcon extends React.Component {
  constructor(){
    super();

    this.state = {
      title: ''
    };

    //Bound methods
    this.onClickEvent = this.onClickEvent.bind( this );
  }

  // Passes up to the parent the prop info / row
  onClickEvent(){
    if( this.props.onClick !== undefined ){
      this.props.onClick( this.props.row, this.props.title );
    }
  }

  // Renders the icon
  render(){
    return(
      <div>
        <div onClick={this.onClickEvent}><i className={this.props.icon + ' react-grid-program-fees-icon'} /></div>
      </div>
    );
  }
}

// Constructs a page lightly nested with ListContainer, this page handles almost all of the functionality that
// ListContainer did (project -- strip ListContainer), the only thing it doesn't do is load ReactGrid which is used
// through out this page. Removed is auth, data, and saving checks (project -- strip ListContainer)
class FeesList extends React.Component {
  constructor(){
    super();

    // Bound Methods
    this.onLoadData = this.onLoadData.bind( this );
    this.onFormatReadOnlyRow = this.onFormatReadOnlyRow.bind( this );
    this.onFormatReadOnlyCellLabel = this.onFormatReadOnlyCellLabel.bind( this );
    this.onEditClicked = this.onEditClicked.bind( this );
    this.onCopyClicked = this.onCopyClicked.bind( this );
    this.onCloseDialog = this.onCloseDialog.bind( this );
    this.onSaveData = this.onSaveData.bind( this );
    this.onHandleException = this.onHandleException.bind( this );
    this.onRefreshData = this.onRefreshData.bind( this );
    this.setChildDataReload = this.setChildDataReload.bind( this );
    this.onCopy = this.onCopy.bind( this );
    this.getCurrentPeriod = this.getCurrentPeriod.bind( this );
    
    // Bound variables
    this.childDataReload = null;
    this.childFilters = null;
    this.rowSelectionToggle = 1;
    this._ismounted = false;

    // Color swaps & row logic
    this.colorPalette = 0;
    this.initialRow = true;
    this.previousPDNIS = undefined;

    // State
    this.state = {
      showDialog: false,
      dialogType: 'edit',
      currentFeePeriodString: '',
      currentFeePeriodStart: '20990101'
    };

  }

  // Loads the page and fetches the current period which is used to
  // build the label.
  componentDidMount(){
    this._ismounted = true;
    this.getCurrentPeriod();
  }

  // Show the dialog for an Edit
  onEditClicked( row, title ){
    this.setState( {
      showDialog: true,
      dialogTitle: title,
      clickedRow: row,
      dialogType: 'edit'
    } );
  }

  // Shows the dialog for a Copy
  onCopyClicked( row, title ){
    this.setState( {
      showDialog: true,
      dialogTitle: title,
      clickedRow: row,
      dialogType: 'copy'
    } );    
  }

  // Closes the dialog, passed up from the dialog
  onCloseDialog( event ){
    this.setState( {
      showDialog: false
    } );
  }

  // Sets the current period values at the page top level
  getCurrentPeriod(){
    const api = new EtelAPI( 'programs/pgmfeesvalidation' );

    //  Params is the row to update
    api.get().then( ( result ) => {
      if( result[0] ){
        const r = result[0];
        this.setState( {
          currentFeePeriodString: ( r['StartDate'] + ' - ' + r['EndDate'] ),
          currentFeePeriodStart: r['StartDate']
        } );
      }
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Passes up a function to be triggered once the parent is done. (Data update)
  setChildDataReload( filter, child_function ){
    this.childFilters = filter;
    this.childDataReload = child_function;
  }

  // Reloads the child components data without losing the filters
  onRefreshData(){
    this.setState( {
      showDialog: false
    } );

    // Call the child fetch row data method to update the altered row, keeping filters
    if( this.childFilters && this.childDataReload ){
      this.childDataReload( this.childFilters );
    }
  
  }

  // Saves/ updates the data of a program fee
  onSaveData( data ){
    const api = new EtelAPI( 'pgmfees' );
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );

    let LEGACY_ID = data['LEGACY_ID'];
    if( LEGACY_ID === null || LEGACY_ID === undefined ){
      LEGACY_ID = 0;
    }

    // Items required
    let payload = {
      PGM_FEE_ID: data['PGM_FEE_ID'],
      PDNIS: data['PDNIS'],
      AD_ID: data['AD_ID'],
      FEE_TYPE_ID: data['FEE_TYPE_ID'],
      FEE_BASE_ID: data['FEE_BASE_ID'],
      FEE_STATE_ID: data['FEE_STATE_ID'],
      FeeRate: data['FeeRate'],
      ACTIVE: data['ACTIVE'],
      AutoComputeBillableCalls: data['AutoComputeBillableCalls'],
      AutoComputeRevenue: data['AutoComputeRevenue'],
      XX_Seconds_ToBeBillable: data['XX_Seconds_ToBeBillable'],
      CCFileDateBegin: data['CCFileDateBegin'],
      CCFileDateEnd: data['CCFileDateEnd'],
      LEGACY_ID: LEGACY_ID
    };

    //  Params is the row to update
    api.update( payload ).then( ( result ) => {
      if( result.length !== 0 ){
        alerts.SUCCESS( 'Program Fee', 'Successfully Updated', 2000 );
        this.onRefreshData();
      }
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Inserts to a new copy fee and updates the old fee
  onCopy( row, source ){
    // Taking values from the current
    const newRowBegin = row['CCFileDateBegin'];
    let oldRowEnd = source['CCFileDateEnd'];

    // If the end date of the old row is bigger, set to new start - 1 day
    if( oldRowEnd >= newRowBegin ){
      
      let today = new Date();

      // End it one day before the start of the new one
      let copyFromEndDate = new Date( today.setDate( today.getDate() - 1 ) );
      const copyFromDay = String( copyFromEndDate.getDate() ).padStart( 2, '0' );
      const copyFromMonth = String( copyFromEndDate.getMonth() + 1 ).padStart( 2, '0' );
      const copyFromYear = copyFromEndDate.getFullYear();
      const copyFromEndDateValue = parseInt( copyFromYear + copyFromMonth + copyFromDay, 10 );
      oldRowEnd = copyFromEndDateValue;
    }

    const api = new EtelAPI( 'pgmfees' );
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    
    // Determining the LEGACY_ID
    let LEGACY_ID = source['LEGACY_ID'];
    if( LEGACY_ID === null || LEGACY_ID === undefined ){
      LEGACY_ID = 0;
    }

    // Copy from row
    let sourceParams = {
      PGM_FEE_ID: source['PGM_FEE_ID'],
      PDNIS: source['PDNIS'],
      AD_ID: source['AD_ID'],
      FEE_TYPE_ID: source['FEE_TYPE_ID'],
      FEE_BASE_ID: source['FEE_BASE_ID'],
      FEE_STATE_ID: source['FEE_STATE_ID'],
      FeeRate: source['FeeRate'],
      ACTIVE: source['ACTIVE'],
      AutoComputeBillableCalls: source['AutoComputeBillableCalls'],
      AutoComputeRevenue: source['AutoComputeRevenue'],
      XX_Seconds_ToBeBillable: source['XX_Seconds_ToBeBillable'],
      CCFileDateBegin: source['CCFileDateBegin'],
      CCFileDateEnd: oldRowEnd,
      LEGACY_ID: LEGACY_ID
    };

    // The new row to insert
    let newParams = {
      PGM_FEE_ID: row['PGM_FEE_ID'],
      PDNIS: row['PDNIS'],
      AD_ID: row['AD_ID'],
      FEE_TYPE_ID: row['FEE_TYPE_ID'],
      FEE_BASE_ID: row['FEE_BASE_ID'],
      FEE_STATE_ID: row['FEE_STATE_ID'],
      FeeRate: row['FeeRate'],
      ACTIVE: row['ACTIVE'],
      AutoComputeBillableCalls: row['AutoComputeBillableCalls'],
      AutoComputeRevenue: row['AutoComputeRevenue'],
      XX_Seconds_ToBeBillable: row['XX_Seconds_ToBeBillable'],
      CCFileDateBegin: row['CCFileDateBegin'],
      CCFileDateEnd: row['CCFileDateEnd'],
      LEGACY_ID: 0
    };

    //  Params is the row to update
    api.update( sourceParams ).then( ( result ) => {
      if( result.length !== 0 ){
        // If update is successful, insert the new row
        api.insert( newParams ).then( ( result ) => {
          alerts.SUCCESS( 'Program Fees', 'Successfully Copied', 5000 );
          this.onRefreshData();
        } ).catch( ( error ) => {
          this.onHandleException( error );
        } );
      }
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  // Handle exceptions
  onHandleException( e ) {
    const { bugsnag, dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    if( e.statusText !== undefined ) {
      alerts.CRITICAL( 'Program Fees', e.statusText );
    } else {
      alerts.CRITICAL( 'Program Fees', 'Unhandled exception occurred.' );
    }
  }

  // Returns additional styles depending on what's in the row
  onFormatReadOnlyRow( args ) {
    const row = args.row;
    let useSpacing = false;

    // 1 = current, 2 = future, 0 = inactive
    let presentValue = isInitialRow( args.row );

    if( this.previousPDNIS === undefined ){
      this.previousPDNIS = row.PDNIS;
      useSpacing = false;
    } else {
      if( this.previousPDNIS !== row.PDNIS ){
        this.colorPalette = Math.abs( ( this.colorPalette - 1 ) * -1 );
        useSpacing = true;
      } else {
        useSpacing = false;
      }
    }

    // Setting the previous PDNIS
    this.previousPDNIS = row.PDNIS;

    // If the current row is the present row
    if( presentValue === 1 ){
      if( useSpacing === true ){
        return {
          overwriteClassName: true,
          className: ( 'react-grid-on-format-row-' + this.colorPalette + '-margin' ),
          style:{}
        };
      } else {
        return {
          overwriteClassName: true,
          className: ( 'react-grid-on-format-row-' + this.colorPalette ),
          style:{}
        };
      }

    // All others
    } else if( presentValue === 2 ) {
      if( useSpacing === true ){
        return {
          overwriteClassName: true,
          className: ( 'react-grid-on-format-row-' + this.colorPalette + '-future-margin' ),
          style:{}
        };
      } else {
        return {
          overwriteClassName: true,
          className: ( 'react-grid-on-format-row-' + this.colorPalette + '-future' ),
          style:{}
        };
      }
    } else {
      if( useSpacing === true ){
        return {
          overwriteClassName: true,
          className: ( 'react-grid-on-format-row-' + this.colorPalette + '-secondary-margin' ),
          style:{}
        };
      } else {
        return {
          overwriteClassName: true,
          className: ( 'react-grid-on-format-row-' + this.colorPalette + '-secondary' ),
          style:{}
        };
      }
    }
  }

  // Adds highlighting to the cell values
  // @arg: args[Object] -> Key:Value of what the cell needs to render, this includes styles which can be extended.
  // --note: No return is needed as the parent is modifying the child object (rendered after this call - sync)
  onFormatReadOnlyCellLabel( args ){
    const value = args.value;
    const column = args.column;
    const index = args.cellIndex;

    // Checks on PGM_ACTIVE value
    if( index === 2 || index === 8 ){
      if( column === 'PGM_ACTIVE' ){
        if( value === 'Not Active' ){
          args.styles = Object.assign( args.styles, {backgroundColor: '#FFFF00', paddingLeft: '4px', paddingRight: '4px'} );
        }
      
      // Defaults to Pgm_Ends, highlights if the date is before today (in the past)
      } else {
        if( pastValue( value ) === true ){
          args.styles = Object.assign( args.styles, {backgroundColor: '#FFFF00', paddingLeft: '4px', paddingRight: '4px'} );
        }
      }
    }

  }

  // Alters the rows look on fetching
  // --note: This component allows for custom row grouping, I've commented this out by request
  onLoadData( data ){

    // Reset of color palette and previous PDNIS
    this.colorPalette = 0;
    this.previousPDNIS = undefined;

    // Checks that a valid filter is present, else it just returns an empty row
    if( ifHasFilters( this.childFilters ) !== true ){
      return [];
    }

    // Row variables
    let modified_rows = [];
    let prev_row = undefined;
    let selection = this.rowSelectionToggle;

    // Altering state if data loaded
    if( data && data.length !== 0 ){
      this.hasData = true;
    }

    for ( let i = 0; i < data.length; i++ ){
      let new_row = data[i];

      if( prev_row === undefined ){
        
        if( selection === 0 ){
          selection = 1;
        } else {
          selection = 0;
        }

        prev_row = new_row;

      } else {
        if( new_row.PDNIS !== prev_row.PDNIS ){
          
          if( selection === 0 ){
            selection = 1;
          } else {
            selection = 0;
          }

          prev_row = new_row;
        }
      }

      const initalRowCheck = isInitialRow( new_row );

      // Current and Future rows are allowed to create Copies
      if( initalRowCheck !== 0 ){
        new_row['ICON_EDIT'] = <DialogIcon onClick={this.onEditClicked} icon={'icon-ikons-pen-3'} row={new_row} title={'Edit ' + new_row.PROGRAM_NAME + ' | ' + new_row.PDNIS} />;
        new_row['ICON_COPY'] = <DialogIcon onClick={this.onCopyClicked} icon={'icon-ikons-copy-2'} row={new_row} title={'Copy ' + new_row.PROGRAM_NAME + ' | ' + new_row.PDNIS} />;
        // Setting future values
        if( initalRowCheck === 2 ){
          new_row['PROGRAM_ACTIVE_TEXT'] = 'Future';
        } else {
          new_row['PROGRAM_ACTIVE_TEXT'] = 'Active';
        }
      } else {
        new_row['ICON_EDIT'] = <DialogIcon onClick={this.onEditClicked} icon={'icon-ikons-pen-3'} row={new_row} title={'Edit ' + new_row.PROGRAM_NAME + ' | ' + new_row.PDNIS} />;
        new_row['PROGRAM_ACTIVE_TEXT'] = 'Not Active';
      }

      // Adding MM/DD/YYYY values
      new_row['CCFileDateBegin_TEXT'] = convertDate( new_row['CCFileDateBegin'] );
      new_row['CCFileDateEnd_TEXT'] = convertDate( new_row['CCFileDateEnd'] );

      modified_rows.push( new_row );
    }

    // Resetting the row colors
    this.rowSelectionToggle = 1;
    this.colorPalette = 0;

    // Returning the new rows
    return modified_rows;
  }

  render(){
    // Label for current fee period
    // -- styles
    const labelContainerStyles = {
      display: 'flex',
      flexDirection: 'row',
      width: '304px',
      marginLeft: 'auto',
      marginTop: '5px'
    };

    // -- Current Fee Period {label}
    const labelLeftSpanStyles = {
      backgroundColor: '#6A7A82',
      color: 'white',
      padding: '4px',
      border: '1px solid #6A7A82',
      borderRadius: '4px 0px 0px 4px'
    };

    // -- Display for the date range {label}
    const labelRightSpanStyles = {
      backgroundColor: '#F5F5F5',
      border: '1px solid #6A7A82',
      padding: '4px',
      borderRadius: '0px 4px 4px 0px'
    };

     // -- prop render {react component}
     let feeStringArray = this.state.currentFeePeriodString.split(' - ')
     let feeString = '';
     if( feeStringArray && feeStringArray[0] !== ''){
       feeString = feeStringArray[0].split('T')[0] + ' - ' + feeStringArray[1].split('T')[0];
     }
    // -- prop render {react component}
    const currentPeriodLabel = (
      <div style={labelContainerStyles}>
        <span style={labelLeftSpanStyles}> Current Fee Period </span>
        <span style={labelRightSpanStyles}>{feeString}</span>
      </div>
    );

    // ListContainer render, note: onRenderGridHeader embeds a component (in this case the current fee period)
    // to ReactGrid
    return (
      <PageAuthorize groups={['Administrators','Operations','Accounting']}>
        <Overlay show={this.state.showDialog} />
        <ListContainer
          id="FeesList"
          layout={layout}
          selectedtab={4}
          showAllRows={true}
          onLoadData={this.onLoadData}
          onFormatReadOnlyRow={this.onFormatReadOnlyRow}
          onFormatReadOnlyCellLabel={this.onFormatReadOnlyCellLabel}
          omitPagination={true}
          onTriggerRowFetch={this.setChildDataReload}
          onRenderGridHeader={ currentPeriodLabel }
          
          ReactGridStyles={
            {
              gridTemplateRows: '5vh 69v',
              height: 'fit-content',
              width: 'auto'
            }
          }

          ReactGridBodyStyles={
            {
              maxHeight: '570px',
              height: 'fit-content',
              cursor: 'pointer',
              overflowX: 'hidden'
            }
          }
          
          ReactGridNoFooter={false}
        />
        <ProgramFeesDialog
          utilityCurrentDate={CONST_YYYYMMDD}
          currentFeePeriodStart={this.state.currentFeePeriodStart}
          dialogType={this.state.dialogType} 
          show={this.state.showDialog} 
          onCancel={this.onCloseDialog}
          onSave={this.onSaveData}
          onCopy={this.onCopy}
          title={this.state.dialogTitle}
          row={ clone( this.state.clickedRow ) }/>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( FeesList ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/fees/components/FeesList.js